var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 10V0H30V10H16.6667ZM0 16.6667V0H13.3333V16.6667H0ZM16.6667 30V13.3333H30V30H16.6667ZM0 30V20H13.3333V30H0ZM3.33333 13.3333H10V3.33333H3.33333V13.3333ZM20 26.6667H26.6667V16.6667H20V26.6667ZM20 6.66667H26.6667V3.33333H20V6.66667ZM3.33333 26.6667H10V23.3333H3.33333V26.6667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard_icon.7290f76cf73a948c2bfe5ee862852e27.svg";
export { ForwardRef as ReactComponent };